import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import _ from "lodash";
import socketIO from "socket.io-client";

const auktionshost = import.meta.env.PROD ? "https://auktion.baur-immobilien.de" : "http://localhost:8081";

export default function Auktionsubersicht({ }) {
   const socketRef = useRef();
   const [bids, setBids] = useState([]);
   const [bidders, setBidders] = useState();
   const [estateId, setEstateId] = useState();
   const [maxBid, setMaxBid] = useState();
   const bidsRef = useRef(false);
   // const [auctionData, setAuctionData]=useState();

   function notifyMe(notificationMessage) {
      if (!("Notification" in window)) {
         // Check if the browser supports notifications
         alert("This browser does not support desktop notification");
      } else if (Notification.permission === "granted") {
         // Check whether notification permissions have already been granted;
         // if so, create a notification
         const notification = new Notification(notificationMessage, { silent: true });
         // …
      } else if (Notification.permission !== "denied") {
         // We need to ask the user for permission
         Notification.requestPermission().then((permission) => {
            // If the user accepts, let's create a notification
            if (permission === "granted") {
               const notification = new Notification(notificationMessage, { silent: true });
               // …
            }
         });
      }
   }

   useEffect(
      () => {
         let params = new URLSearchParams(document.location.search);
         const url_id = params.get("estateid");
         setEstateId(url_id);

         if (url_id && !socketRef.current) {
            socketRef.current = socketIO.connect(auktionshost, {
               withCredentials: true,
               // auth: "Basic QmF1cmltbW86QXVrdGlvbjAwMQ==",
               // Authorization: "Basic QmF1cmltbW86QXVrdGlvbjAwMQ==",
               extraHeaders: {
                  // "my-custom-header": "abcd",
                  // Authorization: "Basic QmF1cmltbW86QXVrdGlvbjAwMQ==",
               },
            });
            console.log(socketRef.current);
            socketRef.current.on("newIncomingBidData_" + url_id, (data) => {
               console.log(data.bids);
               if (bidsRef.current) {
                  console.log("neues gebot");
               }
               bidsRef.current = true;
               setBids(data.bids);

               if (data.max_bid) {
                  setMaxBid(data.max_bid);
                  notifyMe(
                     "Aktuelles Maximalgebot: " +
                        new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(data.max_bid)
                  );
               }
            });
            socketRef.current.on("newIncomingBidderData_" + url_id, (data) => {
               console.log(data.reduce((oldObj, bidderite) => ({ ...oldObj, [bidderite.id]: bidderite }), {}));
               setBidders(data.reduce((oldObj, bidderite) => ({ ...oldObj, [bidderite.id]: bidderite }), {}));
            });

            socketRef.current.on("reconnect", (attempt) => {
               console.log("reconnected: " + attempt);
            });
            socketRef.current.on("connect", () => {
               console.log("connected: ");
               socketRef.current.emit("getAuctionData", {
                  estateId: url_id,
               });
            });
            socketRef.current.on("disconnect", () => {
               console.log("disconnected");
            });
         }
      },
      [
         /* estateId, user */
      ]
   );

   useEffect(() => {
      let params = new URLSearchParams(document.location.search);
      const url_id = params.get("estateid");
   }, []);

   return (
      <>
         <div className="m-5">
            <h2>
               {bids.length} Gebote zu Objekt {estateId}
            </h2>
            {maxBid && (
               <h5>
                  Maximalgebot:{" "}
                  <strong>
                     {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(maxBid)}
                  </strong>
               </h5>
            )}

            {bids.length > 0 && bidders && (
               <table className="mt-3">
                  <thead>
                     <tr>
                        <th>Preis</th>
                        <th>Zeit</th>
                        <th>Bieter</th>
                        <th>user_id</th>
                     </tr>
                  </thead>
                  <tbody>
                     {bids.map((bid) => {
                        return (
                           <tr>
                              <td style={{ fontWeight: 700, fontSize: "larger", textAlign: "right" }}>
                                 {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
                                    bid.price
                                 )}
                              </td>
                              <td className="px-5">{new Date(bid.bid_time).toLocaleString()}</td>
                              <td className="px-5">
                                 {bidders[bid.user_id] ? bidders[bid.user_id].user_name : "Startgebot"}
                              </td>
                              <td className="px-5">{bid.user_id}</td>
                           </tr>
                        );
                     })}
                  </tbody>
               </table>
            )}
         </div>
      </>
   );
}
